import { render } from "./DatePicker.vue?vue&type=template&id=08b3d775&scoped=true&ts=true"
import script from "./DatePicker.vue?vue&type=script&lang=ts"
export * from "./DatePicker.vue?vue&type=script&lang=ts"

import "./DatePicker.vue?vue&type=style&index=0&id=08b3d775&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08b3d775"]])

export default __exports__